import { FlowStep } from '@/interfaces/requirement/index';
import { RequirementService } from '@/services/requirement/requirement.service';
import { StoreState } from '@/store';
import { State } from '@/store/login/reducer';
import { getCurrentUserData } from '@/store/login/selectors';
import { deofuscate, ofuscate } from '@/utils/obfuscation';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Store } from '@ngrx/store';

@Component({
  selector: 'app-success-task-update',
  templateUrl: './success-task-update.component.html',
  styleUrls: ['./success-task-update.component.css'],
})
export class SuccessTaskUpdateComponent implements OnInit {

  email: string = '';
  requestId: string = '';
  storeUserData: Partial<State> = {};

  constructor(
    public route: ActivatedRoute,
    public router: Router,
    private store: Store<StoreState>,
    public requirementService: RequirementService,
  ) {
    getCurrentUserData(this.store).subscribe({
      next: (userData) => {
        this.storeUserData = userData;
      },
    });
  }

  ngOnInit() {
    this.route.params.subscribe(({ ofuscatedData }) => {
      const params = deofuscate(ofuscatedData);
      this.requestId = params.id;
    });
  }

  goToRequestDetail() {
    const ofuscateData = ofuscate({ id: this.requestId });
    this.router.navigateByUrl(`/tasks/detail/${ofuscateData}`);
  }
}
